import { memo } from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, Grid, FormHelperText } from "@mui/material";
import TextField from "@mui/material/TextField";
import classNames from "classnames";
import { DatePicker } from "@mui/x-date-pickers";
import useStyles from "./styles";
import { useI18n } from "../../providers/I18n/I18n";

const Datepicker = (props) => {
  const classes = useStyles();
  const { t } = useI18n();
  const {
    id,
    isRequired = true,
    label,
    value,
    onChange,
    minDate = undefined,
    maxDate = undefined,
    errorMessage,
    isErrorOccurs,
  } = props;

  return (
    <FormControl className={classes.Datepicker}>
      <InputLabel
        required={isRequired}
        className={classNames(classes.DatePickerLabel, classes.inputLabel)}
        htmlFor={id}
        error={isErrorOccurs}
      >
        {label}
      </InputLabel>
      <DatePicker
        InputAdornmentProps={{
          position: "end",
        }}
        disablePast={true}
        id={id}
        value={value ? new Date(value) : null}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        slotProps={{
          textField: {
            InputProps: {
              style: {
                height: "37px",
                marginTop: "14px",
              },
            },
            variant: "outlined",
          },
        }}
      />
      {isErrorOccurs && (
        <Grid container>
          <FormHelperText data-testid={`errors-${id}`} className={classes.errorSpan}>
            {t(errorMessage)}
          </FormHelperText>
        </Grid>
      )}
    </FormControl>
  );
};

Datepicker.propTypes = {
  id: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  isErrorOccurs: PropTypes.bool,
};

export default memo(Datepicker);
